import { closeHoverPop } from "../lib/useHoverOpen";
import React from "react";
import { ChevronDown } from "lucide-react";
import { useSortByTeam } from "../lib/SortByTeamContext";

// Standardized nav toggle (Leaderboards pattern). A compact trigger that opens
// its options in the SHARED drawer row below. One toggle is always open; hover
// switches + sticks. Regular opacity; highlighted (purple) when it's the open one.
export function FilterTrigger({ id, label, testId, disabled = false }) {
    const { openGroup, setOpenGroup } = useSortByTeam();
    const active = openGroup === id && !disabled;
    if (disabled) {
        return (
            <button type="button" disabled aria-disabled="true" data-testid={testId || `nav-${id}-trigger`}
                title="Not available for goalies"
                className="inline-flex items-center gap-1.5 rounded-lg border border-white/10 bg-black/20 px-2.5 py-1.5 text-[11px] font-bold uppercase tracking-wider text-white/25 cursor-not-allowed opacity-50">
                {label}<ChevronDown className="h-3.5 w-3.5" />
            </button>
        );
    }
    return (
        <button type="button" onClick={() => setOpenGroup(active ? null : id)} onMouseEnter={() => { closeHoverPop(); setOpenGroup(id); }}
            data-testid={testId || `nav-${id}-trigger`}
            style={active ? { backgroundColor: "rgba(157,76,221,0.20)", borderColor: "rgba(157,76,221,0.45)" } : undefined}
            className={`inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1.5 text-[11px] font-bold uppercase tracking-wider transition-colors ${active ? "text-[#C9A6F0] border-transparent" : "border-white/15 bg-black/25 text-[#C9A6F0] hover:text-white"}`}>
            {label}<ChevronDown className={`h-3.5 w-3.5 transition-transform ${active ? "rotate-180" : ""}`} />
        </button>
    );
}

// Left-hand label inside the shared drawer row.
export function DrawerTitle({ children }) {
    return <span className="font-heading text-base uppercase tracking-tight leading-none font-black text-white self-center mr-1" data-testid="nav-drawer-title">{children}</span>;
}

// A plain single-press toggle button (no drawer). Press once = on, again = off.
export function ToggleTrigger({ id, label, active = false, onToggle, testId, accent = "157,76,221" }) {
    return (
        <button type="button" onClick={onToggle} data-testid={testId || `nav-${id}-trigger`}
            aria-pressed={active}
            style={active
                ? { backgroundColor: `rgba(${accent},0.85)`, borderColor: `rgba(${accent},0.9)`, boxShadow: `0 0 14px rgba(${accent},0.45)` }
                : { color: `rgba(${accent},0.9)` }}
            className={`inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1.5 text-[11px] font-bold uppercase tracking-wider transition-colors ${active ? "text-white border-transparent" : "border-white/15 bg-black/25 hover:text-white"}`}>
            {label}
        </button>
    );
}
